import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", null, "Edit alarm " + _toDisplayString(_ctx.id), 1),
    _hoisted_1,
    _createElementVNode("div", null, [
      _createVNode(_component_RouterLink, { to: { name: 'alarms' } }, {
        default: _withCtx(() => [
          _createTextVNode("Back to Alarms")
        ]),
        _: 1
      })
    ])
  ], 64))
}